/**
 * Tolère les écarts de syntaxe sur les attributs des tags Hector whitelistés.
 * - Whitespace autour de = (type= "x", type ="x", type = "x")
 * - Apostrophes simples (type='x') → guillemets doubles
 * - Guillemets typographiques (ref=“x”, ref=«x») → guillemets doubles : le
 *   parseur des MarkdownRenderer ne lit que `"…"`, une citation ainsi écrite
 *   resterait affichée en balise brute.
 *
 * S'applique uniquement aux 3 tags whitelistés : hector-link, hector-quote,
 * hector-callout. Les autres tags traversent intacts.
 */
// Valeur d'attribut à délimiteurs APPARIÉS : une apostrophe dans `“Cour d'appel”`
// ou des chevrons dans `"Décision « Martin »"` ne coupent pas la valeur. Une
// valeur typographique ne peut pas contenir `"` : elle deviendrait `"…"…"`.
const VALUE = `"[^"]*"|'[^']*'|[“”][^“”"]*[“”]|«[^»"]*»`;
const HECTOR_TAG_RE = new RegExp(`<(hector-(?:link|quote|callout))((?:\\s+[a-z_]+\\s*=\\s*(?:${VALUE}))+)(\\s*\\/?)>`, 'g');
const ATTR_RE = new RegExp(`([a-z_]+)\\s*=\\s*(${VALUE})`, 'g');

export function whitespaceAttrs(text: string): string {
  if (!text) return text;

  return text.replace(HECTOR_TAG_RE, (_, tag: string, attrsRaw: string, selfClose: string) => {
    const canonicalAttrs: string[] = [];
    let m: RegExpExecArray | null;
    ATTR_RE.lastIndex = 0;
    while ((m = ATTR_RE.exec(attrsRaw)) !== null) {
      canonicalAttrs.push(`${m[1]}="${m[2]!.slice(1, -1)}"`);
    }
    return `<${tag} ${canonicalAttrs.join(' ')}${selfClose}>`;
  });
}
